module.exports = __webpack_public_path__ + "img/bit-3.c9808745.png";